(function () {
  'use strict';

  document.querySelectorAll('[data-dn-flavor-filters]').forEach(function (filterBar) {
    var grid = filterBar.parentElement.querySelector('[data-dn-flavor-cards]');
    if (!grid) return;

    var cards = grid.querySelectorAll('.dn-flavor-card');
    var buttons = filterBar.querySelectorAll('[data-dn-flavor-filter]');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var filter = button.getAttribute('data-dn-flavor-filter');

        buttons.forEach(function (b) {
          b.classList.toggle('is-active', b === button);
        });

        cards.forEach(function (card) {
          var show = filter === 'all' || card.getAttribute('data-category') === filter;
          card.classList.toggle('dn-flavor-card--hidden', !show);
        });
      });
    });
  });
})();
